// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-2j5","type":"styles_type__1qaSb","choices":"styles_choices__2p9Rl"};